module.exports = __webpack_public_path__ + "static/img/resume-oblique.cab84a2.png";